import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'link', 'container', 'removeLink', 'hiddenField']

  connect() {
    this.hideRemoveWhenOneField()
  }

  add(event) {
    const time = new Date().getTime()
    const regexp = new RegExp($(this.linkTarget).data('id'), 'g')

    let method = 'prepend'
    if (this.data.has('method')) {
      method = this.data.get('method')
    }

    $(this.containerTarget)[method]($(this.linkTarget).data('fields').replace(regexp, time))

    // need to call this so the client side validations are applied to this new
    // field
    $(this.element).validate()

    $(this.removeLinkTargets).show()
    this.hiddenNoResults();
    event.preventDefault()
  }

  hideRemoveWhenOneField() {
    let numberOfFields = 0
    this.hiddenFieldTargets.forEach(function(hiddenField) {
      if (hiddenField.value == 'false') {
        numberOfFields++
      }
    })

    if (numberOfFields == 1) {
      $(this.removeLinkTargets).hide()
    }
  }

  hiddenNoResults(){
    if (this.elementsNoResults) {
      return
    }
    this.elementsNoResults = document.querySelector('.add-fields__no-results');
    if (this.elementsNoResults) {
      this.elementsNoResults.classList.add('tw-hidden');
    }
  }
}
